// @ts-nocheck
import React from 'react';
import { CartApi } from '~/api/CartApi';
import { getFollowupPaymentInfo, putCancelOrder, getOrders } from '~/api/order';
import { CLIENT_TYPES, ORDER_STATE, SERVICE_TYPE, SeverityLevel_error } from '~/constant';
import { selectPayment } from '~/store/legacy/selector/paymentSelectors';
import * as shoppingCartSelectors from '~/store/legacy/selector/shoppingCartSelectors';
import { currentTipDollarValue } from '~/store/legacy/selector/shoppingCartSelectors';
import { getSessionItem } from '~/store/storage';
import { fbEvents } from '~/third_party/Facebook';
import { googleTagManager } from '~/third_party/GoogleTagManager';
import { mixpanel } from '~/third_party/Mixpanel';
import { extract } from '~/utils/jsonApi';
import { DEFAULT_DOLLAR_TIPS, DEFAULT_PERCENTAGE_TIPS } from '../reducers/shoppingCartReducers';
import { openAlert } from './alertActions';
import { closeDialog, openDialog } from './dialogActions';
import * as Sentry from '@sentry/react';
import ImpactTrack from '~/third_party/Impact';
// eslint-disable-next-line no-unused-vars
import { roundTo2Digits, toPrice } from '~/utils/format';
// eslint-disable-next-line no-unused-vars
import { useSelector } from 'react-redux';
// eslint-disable-next-line no-unused-vars
import { getUserStore, selectUser } from '../selector/userSelectors';
import sha1 from 'crypto-js/sha1';
import { selectUserServiceRegionId } from '~/store/legacy/selector/userSelectors.js';
import { AppsflyerPBA } from '~/third_party/Appsflyer';
const BASE = 'cart :';
import { SeverityLevel_info } from '~/constant.js';

export const shoppingCartActionTypes = {
  initCart: `${BASE} init`,
  addToCart: `${BASE} add item`,
  changeMeal: `${BASE} update item`,
  clearCart: `${BASE} clear`,

  setDeliveryTime: `${BASE} set delivery time`,
  setAddressId: `${BASE} set delivery address`,
  setTips: `${BASE} set tips`,
  tipsInputChange: `${BASE} tips input change`,
  setDeliveryNote: `${BASE} set delivery note`,
  setMealNote: `${BASE} set meal note`,

  getTimesStart: `${BASE} times : fetch start`,
  getTimesSuccess: `${BASE} times : fetch SUCCESS`,
  getTimesFailed: `${BASE} times : fetch FAILED`,

  setPromocode: `${BASE} set promo code`,
  applyPromoCodeStart: `${BASE} apply promo code : fetch start`,
  applyPromoCodeSuccess: `${BASE} apply promo code : fetch SUCCESS`,
  applyPromoCodeFailed: `${BASE} apply promo code : fetch FAILED`,

  checkoutOrderStart: `${BASE} checkout : fetch start`,
  checkoutOrderSuccess: `${BASE} checkout : fetch SUCCESS`,
  checkoutOrderFailed: `${BASE} checkout : fetch FAILED`,

  placeOrderStart: `${BASE} place order : persist start`,
  placeOrderSuccess: `${BASE} place order : persist SUCCESS`,
  placeOrderFailed: `${BASE} place order : persist FAILED`,

  setError: `${BASE} set error`,
  removeError: `${BASE} remove (unset) error`,
  clearErrors: `${BASE} clear errors`,
};

export const initCart = () => (dispatch) => {
  const shoppingCart = getSessionItem('shoppingCart');
  try {
    if (shoppingCart) {
      dispatch({
        type: shoppingCartActionTypes.initCart,
        cartFromSession: JSON.parse(shoppingCart),
      });
    }
  } catch (e) {
    // Do nothing
  }
};

export const addToCart = ({ meal, mealNote, serviceType, router, deliveryGroup = null }) => (
  dispatch,
  getState,
  { intl }
) => {
  const state = getState();
  const {
    meals: shoppingCartMeals,
    deliveryGroup: shoppingCartDeliveryGroup,
    serviceType: shoppingCartServiceType,
  } = shoppingCartSelectors.selectShoppingCartData(state);
  const serviceRegionId = selectUserServiceRegionId(state);
  const { userStore } = state;
  const { formatMessage } = intl(state);
  Sentry.addBreadcrumb({
    category: 'Cart',
    message: 'Add to Cart',
    level: SeverityLevel_info,
    data: {
      meal,
      mealNote,
      serviceType,
      deliveryGroup,
    },
  });
  if (shoppingCartMeals.length > 0) {
    if (serviceType !== shoppingCartServiceType) {
      return dispatch(
        openDialog({
          title: formatMessage({ id: 'actions.shoppingCart.different_service_type.title' }),
          message: formatMessage({ id: 'actions.shoppingCart.different_service_type.message' }),
          buttons: [
            goToCheckout({
              text: formatMessage({ id: 'actions.shoppingCart.checkout' }),
              dispatch,
              router,
            }),
            clearCartButton({
              text: formatMessage({ id: 'actions.shoppingCart.clear_cart' }),
              dispatch,
            }),
          ],
        })
      );
    } else if (
      serviceType === SERVICE_TYPE.DELIVERY &&
      deliveryGroup.id !== shoppingCartDeliveryGroup.id
    ) {
      return dispatch(
        openDialog({
          title: formatMessage({ id: 'actions.shoppingCart.delivery_group_missed.title' }),
          message: formatMessage({ id: 'actions.shoppingCart.delivery_group_missed.message' }),
          buttons: [
            goToCheckout({
              text: formatMessage({ id: 'actions.shoppingCart.checkout' }),
              dispatch,
              router,
            }),
            clearCartButton({
              text: formatMessage({ id: 'actions.shoppingCart.clear_cart' }),
              dispatch,
            }),
          ],
        })
      );
    }
  }

  googleTagManager.trackAddToCart();
  fbEvents.trackAddToCart();
  AppsflyerPBA.trackWebAddToCart({
    meal: AppsflyerPBA.getMeal(meal),
    address_id: userStore.addressId,
    service_type: serviceType,
    service_region: serviceRegionId,
  });
  dispatch({
    type: shoppingCartActionTypes.addToCart,
    addressId: userStore.addressId,
    meal,
    mealNote,
    serviceType,
    deliveryGroup,
  });
};

export const incrementMealQuantity = ({ meal }) => (dispatch, getState) => {
  const index = shoppingCartSelectors.selectIndex(meal)(getState());
  if (index >= 0) {
    const quantity = meal.quantity + 1;
    dispatch({
      type: shoppingCartActionTypes.changeMeal,
      index,
      meal: {
        ...meal,
        ...{
          quantity,
        },
      },
    });
  }
};

export const decrementMealQuantity = ({ meal }) => (dispatch, getState) => {
  const index = shoppingCartSelectors.selectIndex(meal)(getState());
  if (index >= 0) {
    const quantity = meal.quantity - 1;
    dispatch({
      type: shoppingCartActionTypes.changeMeal,
      index,
      meal:
        quantity > 0
          ? {
            ...meal,
            ...{
              quantity,
            },
          }
          : null,
    });
  }
};

export const updateMealNotes = ({ mealId, newNote }) => (dispatch) => {
  dispatch({
    type: shoppingCartActionTypes.setMealNote,
    mealId,
    newNote,
  });
};

export const getDeliveryTimes = () => async (dispatch, getState) => {
  const { meals, serviceType, deliveryGroup } = shoppingCartSelectors.selectShoppingCartData(
    getState()
  );
  dispatch({
    type: shoppingCartActionTypes.getTimesStart,
  });
  Sentry.addBreadcrumb({
    category: 'Cart',
    message: 'Deilvery Times',
    level: SeverityLevel_info,
    data: {
      serviceType,
      deliveryGroupId: deliveryGroup && deliveryGroup.id,
      mealInstanceIds: meals.map((meal) => meal.id),
    },
  });
  try {
    const times = await CartApi.getDeliveryTimes({
      serviceType,
      deliveryGroupId: deliveryGroup && deliveryGroup.id,
      mealInstanceIds: meals.map((meal) => meal.id),
    });
    dispatch({
      type: shoppingCartActionTypes.getTimesSuccess,
      times,
    });
  } catch (error) {
    Sentry.addBreadcrumb({
      category: 'Cart',
      message: 'Deilvery Times',
      level: SeverityLevel_error,
      data: error,
    });
    dispatch({
      type: shoppingCartActionTypes.getTimesFailed,
    });
  }
};

export const setDeliveryTime = (time) => (dispatch) => {
  mixpanel.track({ name: 'delivery time selected', properties: { time } });
  dispatch({
    type: shoppingCartActionTypes.setDeliveryTime,
    time,
  });
};

export const setDeliveryNote = (note) => (dispatch) => {
  mixpanel.track({ name: 'delivery instructions added', properties: { note } });
  dispatch({
    type: shoppingCartActionTypes.setDeliveryNote,
    note,
  });
};

/**
 * Get all the information needed for checkout, including totals
 */
export const checkout = () => async (dispatch, getState, { intl }) => {
  const state = getState();
  dispatch({
    type: shoppingCartActionTypes.checkoutOrderStart,
  });
  try {
    const response = await fetchCheckoutInformation(dispatch, state, intl);
    handleCheckoutOrderSuccess(response, dispatch, state);
  } catch (e) {
    Sentry.captureException(e);
    dispatch(handleCheckoutFailed(e));
    dispatch({
      type: shoppingCartActionTypes.checkoutOrderFailed,
    });
  }
};

/**
 * Collect the users money and create their order
 * @param {any} router
 */
export const placeOrder = (router, stripe) => async (dispatch, getState, { intl }) => {
  const state = getState();
  const { formatMessage } = intl(state);
  const {
    stop,
    addressId,
    deliveryGroup,
    time,
    serviceType,
    meals,
    mealNotes,
    note,
    promoCode,
    mealSummary
  } = shoppingCartSelectors.selectShoppingCartData(state);
  const serviceRegionId = selectUserServiceRegionId(state);

  const tipValue = serviceType === SERVICE_TYPE.DELIVERY ? currentTipDollarValue(state) : null;
  Sentry.addBreadcrumb({
    category: 'Cart',
    message: 'Checkout (place order)',
    level: SeverityLevel_info,
    data: {
      serviceType,
      meals,
      deliveryGroupId: deliveryGroup ? deliveryGroup.id : null,
      addressId,
      tipValue,
    },
  });
  if (serviceType === SERVICE_TYPE.DELIVERY && (!deliveryGroup || !deliveryGroup.id)) {
    Sentry.addBreadcrumb({
      category: 'Cart',
      message: 'Checkout place order - missing delivery group',
      level: SeverityLevel_error,
    });
  }
  const { selectedMethod } = selectPayment(state);
  if (!time) {
    Sentry.addBreadcrumb({
      category: 'Cart',
      message: 'Checkout place order - missing time',
      level: SeverityLevel_error,
    });
    return dispatch(
      openDialog({
        title: formatMessage({ id: 'actions.shoppingCart.no_available_time.title' }),
        message: formatMessage({ id: 'actions.shoppingCart.no_available_time.content' }),
        buttons: [
          clearCartButton({
            text: formatMessage({ id: 'actions.shoppingCart.clear_cart' }),
            dispatch,
          }),
        ],
      })
    );
  }
  if (!selectedMethod) {
    Sentry.addBreadcrumb({
      category: 'Cart',
      message: 'Checkout place order - missing payment method',
      level: SeverityLevel_error,
    });
    return dispatch(
      openDialog({
        title: formatMessage({ id: 'actions.shoppingCart.no_available_time.title' }),
        message: formatMessage({ id: 'actions.shoppingCart.no_available_time.content' }),
        buttons: [
          clearCartButton({
            text: formatMessage({ id: 'actions.shoppingCart.clear_cart' }),
            dispatch,
          }),
        ],
      })
    );
  }

  dispatch({
    type: shoppingCartActionTypes.clearErrors,
  });

  dispatch({
    type: shoppingCartActionTypes.placeOrderStart,
  });
  try {
    const payment = extractPayment(selectedMethod);
    const isStripe = payment.processor === CLIENT_TYPES.STRIPE;
    const {
      order: { orders },
    } = state;
    let isFirstPurchaseFlag = -1;// unknow flag
    if (Object.values(orders).length === 0) {
      try {
        const data = await getOrders(0);
        const ordersBeforePlaceOrder = extract(data, 'order') || [];
        if (Object.values(ordersBeforePlaceOrder).length === 0) {
          isFirstPurchaseFlag = 1;
        } else {
          isFirstPurchaseFlag = 0;
        }
      } catch (e) { }

    } else {
      isFirstPurchaseFlag = 1;
    }
    const response = await CartApi.placeOrder({
      serviceType,
      meals,
      mealNotes,
      deliveryGroupId: deliveryGroup && deliveryGroup.id,
      stopId: stop && stop.id,
      addressId,
      checkoutMode: false,
      deliveryDateTime: time.end_at,
      note,
      tips: tipValue,
      promoCode,
      ...payment,
      // new stripe flow means stripe 3d secure
      paymentMethodId: isStripe ? 'new_stripe_flow_enabled' : payment.paymentMethodId,
    });
    const { data, included } = response;
    let promoCodeAppliedAmount = 0;
    const order = extract(data, 'order')[0];
    // find promoCode amount
    //Promo Code (${promoCode})
    let promotionCodeDeduction = (response.data?.included || []).find((item) => {
      let item_attributes = item.attributes;
      if (item_attributes && item_attributes["deduction_source"] === 'promo'
        && item_attributes["description"] === `Promo Code (${promoCode})`) {
        return true;
      } else {
        return false;
      }
    });
    if (promotionCodeDeduction) {
      promoCodeAppliedAmount = parseFloat(promotionCodeDeduction.attributes.amount_applied) || 0;
    }


    trackOrder(state, order, isFirstPurchaseFlag, serviceRegionId, promoCodeAppliedAmount);
    if (order.attributes.state === ORDER_STATE.UNAUTHORIZED) {
      if (
        payment.processor === CLIENT_TYPES.STRIPE &&
        order.attributes.paymentUri &&
        payment.paymentMethodId
      ) {
        // Stripe orders that are UNAUTHORIZED but have a client secret need to be
        // checked against Stripe 3d secure via Stripe SDK
        const finalPaymentInfo = await getFollowupPaymentInfo(order.attributes.paymentUri);
        const stripeResult = await stripe.confirmCardPayment(
          finalPaymentInfo.attributes.payment_intent_client_secret,
          {
            payment_method: payment.paymentMethodId,
          },
          // Let Stripe do the hard work. It will open it's own UI to handle the confirmation
          { handleActions: true }
        );
        if (stripeResult.error) {
          const { amounts, number: orderNumber } = order.attributes;
          await putCancelOrder(orderNumber);
          AppsflyerPBA.trackWebOrderCancelled({
            revenue: amounts.find((amount) => amount.name === 'total').amount || 0,
            order_id: orderNumber,
            promo_code: promoCode || '',
            promo_code_amount: promoCodeAppliedAmount,
            service_region: serviceRegionId,
            order_type: serviceType,
            currency: 'USD',
          });
          throw new Error(stripeResult.error.message);
        }
      } else if (payment.paymentVendor === CLIENT_TYPES.ALIPAY) {
        const paymentUrl = `/thirdparty_payment/?payment_uri=${order.attributes.paymentUri}`;
        // window.ap is inserted by alipay
        if (window.ap) {
          window.ap.pushWindow(paymentUrl);
        } else {
          window.open(
            paymentUrl,
            '_blank' // <- This is what makes it open in a new window.
          );
        }
      }
    }


    mixpanel.track({ name: 'Order Placed', properties: { serviceType, web: 'true', ...mealSummary } });
    dispatch(
      openAlert({
        message: formatMessage({ id: 'actions.shoppingCart.order_has_been_placed' }),
        variant: 'success',
      })
    );
    dispatch({
      type: shoppingCartActionTypes.placeOrderSuccess,
      order,
    });
    await router.replace('/confirmation/[orderNumber]', `/confirmation/${order.attributes.number}`);
    dispatch(clearCart());
  } catch (e) {
    Sentry.addBreadcrumb({
      category: 'Cart',
      message: 'Checkout place order - order failed',
      level: SeverityLevel_error,
    });
    dispatch(handleCheckoutFailed(e));
    dispatch({
      type: shoppingCartActionTypes.placeOrderFailed,
    });
  }
};

export const clearCart = () => (dispatch) => {
  dispatch({
    type: shoppingCartActionTypes.clearCart,
  });
};

export const clearErrors = () => (dispatch) => {
  dispatch({
    type: shoppingCartActionTypes.clearErrors,
  });
};

export const setPromocode = (promoCode) => (dispatch) => {
  dispatch({
    type: shoppingCartActionTypes.setPromocode,
    promoCode,
  });
};

export const applyPromoCode = () => async (dispatch, getState, { intl }) => {
  const state = getState();
  const {
    shoppingCart: { promoCode },
  } = state;
  dispatch({
    type: shoppingCartActionTypes.applyPromoCodeStart,
    promoCode,
  });
  dispatch({
    type: shoppingCartActionTypes.removeError,
    errorType: 'promoCode',
  });
  try {
    const response = await fetchCheckoutInformation(dispatch, state, intl);
    await dispatch({
      type: shoppingCartActionTypes.applyPromoCodeSuccess,
      promoCode,
    });
    dispatch(
      openAlert({
        message: 'Applied promo code successfully.',
        variant: 'success',
      })
    );
    dispatch({
      type: shoppingCartActionTypes.checkoutOrderStart,
    });
    // Since the totals are already available extract the data
    handleCheckoutOrderSuccess(response, dispatch, state);
  } catch (e) {
    const { response } = e;
    let errorMessage = 'Failed to apply promo code';
    if (response?.data?.data?.promo_ineligible && response.data.errors?.length) {
      errorMessage = response.data.errors[0];
    }
    dispatch(
      openAlert({
        message: errorMessage,
        variant: 'error',
      })
    );
    dispatch({
      type: shoppingCartActionTypes.setError,
      errorType: 'promoCode',
      message: errorMessage,
      isLocal: true,
    });
    dispatch({
      type: shoppingCartActionTypes.applyPromoCodeFailed,
    });
    // Need to recalculate totals sans promo code
    dispatch(checkout());
  }
};

export const setTips = (tipDollarValue, tipDisplayValue) => (dispatch) => {
  dispatch({
    type: shoppingCartActionTypes.setTips,
    tipDollarValue,
    tipDisplayValue,
  });
};

/**
 *
 * @param {object} props
 * @param {'cannedPercentage'|'cannedCurrency'|'freeCurrency'} props.inputType
 * @param {number} props.value
 * @returns Thunk
 */
export function onTipsInputChangeAction(props) {
  return function onTipsInputChangeThunk(dispatch, getState) {
    const { inputType, value } = props;
    const state = getState();
    const total = shoppingCartSelectors.checkoutTotalForTips(state);
    const options = total && total > 20 ? DEFAULT_PERCENTAGE_TIPS : DEFAULT_DOLLAR_TIPS;
    dispatch({
      type: shoppingCartActionTypes.tipsInputChange,
      payload: {
        inputType,
        value,
        options,
      },
    });
  };
}

function speicalErrorMessage(inputError) {
  switch (inputError) {
    case 'PreorderOrders::Errors::DeprecationWarning': {
      return (
        <div>
          This item is for pre-order only. Please download Chowbus mobile app to checkout. Download{' '}
          <a href='https://apps.apple.com/us/app/chowbus-next-stop-chow/id1053160529?ls=1'>
            here for Apple
          </a>{' '}
          and{' '}
          <a href='https://play.google.com/store/apps/details?id=com.chowbus.chowbus'>
            here for Android
          </a>
          .
        </div>
      );
    }
    default: {
      return <div>{inputError}</div>;
    }
  }
}

const handleCheckoutFailed = (e) => (dispatch) => {
  const { response } = e;
  if (response) {
    const {
      data: { errors },
    } = response;
    if (errors) {
      const error = errors.map(speicalErrorMessage);
      dispatch(
        openDialog({
          title: 'Failed to checkout',
          message: error,
          buttons: [
            {
              text: 'Clear cart',
              onClick: () => {
                dispatch(clearCart());
                dispatch(closeDialog());
              },
            },
          ],
        })
      );
    }
  } else if (e.errors) {
    dispatch(
      openAlert({
        message: `Failed to checkout - ${e.errors.join('. ')}`,
        variant: 'error',
      })
    );
  } else if (e.message) {
    // some errors are flatter than the above, but still have a message. eg. stripe error
    dispatch(
      openAlert({
        message: `Failed to checkout - ${e.message}`,
        variant: 'error',
      })
    );
  } else {
    dispatch(
      openAlert({
        message: 'Failed to checkout',
        variant: 'error',
      })
    );
  }
};

const trackOrder = (state, order, isFirstPurchaseFlag, serviceRegionId, promoCodeAppliedAmount) => {
  const { amounts, number: orderNumber } = order.attributes;
  const amountGroups = shoppingCartSelectors.checkoutAmountsGrouped(state);
  const subTotal = shoppingCartSelectors.checkoutSubtotalAmount(state);
  const amountDeductions = shoppingCartSelectors.selectCheckoutAmountDeductions(state);
  const totalAmount = shoppingCartSelectors.checkoutTotalAmount(state);
  const totalWithTipsValue = shoppingCartSelectors.checkoutTotalWithTips(state);
  const checoutTips = shoppingCartSelectors.checkouTips(state);


  let orderDiscount = 0;//all deduction金额
  let orderTax = 0;
  let orderFee = 0;
  let orderDishItemsSubTotal = 0;
  let orderSubTotal = 0;// orderDishItemsSubTotal + fee + tips
  let orderTotal = parseFloat(totalWithTipsValue);
  let orderTips = checoutTips || 0;
  let orderAddition = 0;
  let orderDeduction = 0;
  let promoCodeAmount = promoCodeAppliedAmount || 0;

  if (amountDeductions) {
    orderDiscount = amountDeductions.reduce((orderDiscount, deduction) => {
      orderDiscount = orderDiscount + parseFloat(deduction.attributes.amountApplied);
      return orderDiscount;
    }, orderDiscount);
  }
  if (amountGroups) {
    Object.keys(amountGroups).map((groupName) => {
      if (groupName !== 'null') {
        if (amountGroups[groupName]) {
          orderTax = amountGroups[groupName].reduce((acc, item) => {
            acc = acc + parseFloat(item.amount);
            return acc;
          }, orderTax);
        }
      } else {
        if (amountGroups[groupName]) {
          orderFee = amountGroups[groupName].reduce((acc, item) => {
            acc = acc + parseFloat(item.amount);
            return acc;
          }, orderFee);
        };
      }
    })
  }

  if (subTotal) {
    // dish amount 
    orderDishItemsSubTotal = parseFloat(subTotal.amount);
  }

  orderAddition = orderFee + orderTips + orderTax;
  orderDeduction = orderDiscount;
  // orderSubTotal = orderDishItemsSubTotal + orderFee + orderTips;

  const {
    order: { orders },
  } = state;
  let triggerFirstPurchase = isFirstPurchaseFlag === 1 || (isFirstPurchaseFlag == -1 && Object.values(orders).length === 0);
  // eslint-disable-next-line no-unused-vars
  const {
    stop,
    addressId,
    deliveryGroup,
    time,
    serviceType,
    meals,
    mealNotes,
    note,
    promoCode,
  } = shoppingCartSelectors.selectShoppingCartData(state);

  let user = selectUser(state);
  let mealObjectList = (meals || []).map((itemMeal) => {
    let { id, quantity, attributes, relationships, customizationOptions } = itemMeal;
    let { name, price, foreignName } = attributes;
    let { name: categoryName } = relationships?.category?.data?.attributes || {};
    let customizationAmount = 0;
    customizationAmount = (Object.keys(customizationOptions).reduce((customizationAmount, customiazationOptionKey) => {
      let { quantity, attributes } = customizationOptions[customiazationOptionKey];
      let { price } = attributes;
      customizationAmount = customizationAmount + quantity * parseFloat(price);
      return customizationAmount;
    }, customizationAmount));
    let subTotal = parseFloat(roundTo2Digits(customizationAmount * quantity + quantity * price));
    return {
      subTotal,
      category: categoryName,
      sku: id,
      quantity: quantity,
      name: name,
      price: parseFloat(roundTo2Digits(1 * price)),
    };
  });
  const total = amounts.find((amount) => amount.name === 'total');


  let { attributes } = order;
  let impactTrackData = {
    orderId: orderNumber,
    customerId: user.id,
    customerEmail: user.email ? sha1(user.email).toString() : '',
    customerStatus: user.is_new_user ? 'New' : 'Returning',
    currencyCode: 'USD',
    orderPromoCode: promoCode || '',

    orderDiscount: orderDeduction || 0,
    orderTax: orderAddition || 0,//tax
    orderSubTotalPostDiscount: total.amount || 0,
    orderSubTotalPreDiscount: orderDishItemsSubTotal,//Order Subtotal (Post-Discount) 
    // orderShipping: 0,//delivery fee

    // orderDishItemsSubTotal,
    // orderTax,
    // orderFee,
    // orderTips,
    // orderDiscount,

    // items: mealObjectList,
  };
  let appsFlyerTrackData = {
    revenue: total.amount || 0,
    order_id: orderNumber,
    promo_code: promoCode || '',
    promo_code_amount: promoCodeAmount,
    service_region: serviceRegionId,
    order_type: serviceType,
    currency: 'USD',
  }


  if (triggerFirstPurchase) {
    ImpactTrack.firstPurchase(impactTrackData);
    AppsflyerPBA.trackWebFirstPurchase(appsFlyerTrackData);
    fbEvents.trackFirstTimePurchase({ total: total.amount });
    googleTagManager.trackFirstPurchase({ total: total.amount });
  } else {
    ImpactTrack.purchase(impactTrackData);
    AppsflyerPBA.trackWebPurchase(appsFlyerTrackData);
    fbEvents.trackPurchase({ total: total.amount });
    googleTagManager.trackPurchase({ total: total.amount });
  }

};

/**
 * Get the 3rd party specific details from a paymentMethod
 * @param {ShoppingCartState.PaymentMethod} paymentMethod
 * @returns { object | ShoppingCartState.StripeExtractedPaymentMethod  | ShoppingCartState.BraintreeExtractedPaymentMethod | ShoppingCartState.AlipayExtractedPaymentMethod }
 */
function extractPayment(paymentMethod) {
  if (!paymentMethod) {
    return {};
  }
  const { identifier, processor } = paymentMethod;
  if (processor === CLIENT_TYPES.STRIPE) {
    return {
      processor,
      paymentMethodId: identifier,
    };
  } else if (processor === CLIENT_TYPES.BRAINTREE) {
    return {
      processor,
      paymentNonce: identifier,
    };
  } else if (processor === CLIENT_TYPES.ALIPAY) {
    // TODO: this value from intercom code.. should change to more solid check
    const isMobile = window.is_mobile;
    return {
      processor,
      paymentVendor: CLIENT_TYPES.ALIPAY,
      terminal: isMobile ? 'wap' : 'online',
    };
  }
  return {};
}

/** Fetches checkout information including totals and promoCode eligiblity */
function fetchCheckoutInformation(dispatch, state, intl) {
  const { formatMessage } = intl(state);
  const {
    addressId,
    deliveryGroup,
    time,
    serviceType,
    meals,
    mealNotes,
    note,
    promoCode,
  } = shoppingCartSelectors.selectShoppingCartData(state);
  Sentry.addBreadcrumb({
    category: 'Cart',
    message: 'Checkout get cart totals',
    level: SeverityLevel_error,
    data: {
      serviceType,
      meals,
      deliveryGroupId: deliveryGroup ? deliveryGroup.id : null,
      addressId,
    },
  });
  if (!time) {
    Sentry.addBreadcrumb({
      category: 'Cart',
      message: 'Checkout get cart totals - missing time',
      level: SeverityLevel_error,
    });
    return dispatch(
      openDialog({
        title: formatMessage({ id: 'actions.shoppingCart.no_available_time.title' }),
        message: formatMessage({ id: 'actions.shoppingCart.no_available_time.content' }),
        buttons: [
          clearCartButton({
            text: formatMessage({ id: 'actions.shoppingCart.clear_cart' }),
            dispatch,
          }),
        ],
      })
    );
  }
  if (serviceType === SERVICE_TYPE.DELIVERY && (!deliveryGroup || !deliveryGroup.id)) {
    Sentry.addBreadcrumb({
      category: 'Cart',
      message: 'Checkout get cart totals - missing delivery group',
      level: SeverityLevel_error,
    });
  }
  return CartApi.fetchCheckout({
    serviceType,
    meals,
    mealNotes,
    deliveryGroupId: deliveryGroup ? deliveryGroup.id : null,
    addressId,
    checkoutMode: true,
    deliveryDateTime: time.end_at,
    note,
    promoCode,
  });
}

/** Extract order data returned from fetchCheckoutInformation */
function handleCheckoutOrderSuccess(apiResponse, dispatch, state) {
  const { data } = apiResponse;
  data.data.id = 'shopping_cart';
  const orders = extract(data, 'order');
  const financialDisclosureObj = extract(data, 'financialDisclosure');

  const orderObj = { ...orders[0] };
  if (financialDisclosureObj) {
    orderObj['financialDisclosure'] = financialDisclosureObj[0];
  }

  // We need to recalc this stuff about tips here because every time the totals change
  // the tips UI might need to change.
  const currentUi = shoppingCartSelectors.uiTips(state);
  // since the order isn't in the state yet, make a fake state so we can reuse selectors
  // TODO: move this whole thing into reducers, wtf
  const fakeState = {
    shoppingCart: {
      order: orderObj,
    },
  };
  const total = shoppingCartSelectors.checkoutTotalForTips(fakeState);
  const newTipOptions = total > 20 ? DEFAULT_PERCENTAGE_TIPS : DEFAULT_DOLLAR_TIPS;
  let newTipType = currentUi.inputType;
  let newTipValue = currentUi.value;

  if (newTipType !== 'freeCurrency') {
    if (total > 20) {
      newTipType = 'cannedPercentage';
    } else {
      newTipType = 'cannedCurrency';
    }
    if (newTipType !== currentUi.inputType) {
      newTipValue = newTipOptions[1].value;
    }
  }

  dispatch({
    type: shoppingCartActionTypes.checkoutOrderSuccess,
    payload: {
      order: orderObj,
      newTipValue,
      newTipOptions,
      newTipType,
    },
  });
}

const goToCheckout = ({ text, dispatch, router }) => ({
  text,
  variant: 'primary',
  onClick: () => {
    dispatch(closeDialog());
    router.push('/checkout', '/checkout');
  },
});

const clearCartButton = ({ text, dispatch }) => ({
  text,
  onClick: () => {
    dispatch(clearCart());
    dispatch(closeDialog());
  },
});
